import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { CostGridComponent } from "./cost-grid.component";
import { CostTableDataModule } from "../../services/cost-table-data/cost-table-data.module";
import { PriceModule } from "libraries/component/price/price.module";
import { ConfigurationResourceModule } from "libraries/service/resources/configuration/configurationResource.module";
import { CostGridBlockContentModule } from "./components/cost-grid-block-content/cost-grid-block-content.module";
import { CostGridBlockValueModule } from "./components/cost-grid-block-value/cost-grid-block-value.module";
import { CostFormGeneratorModule } from "../../services/cost-form-generator/cost-form-generator.module";
import { QuotationQuotationsResourceModule } from 'libraries/service/resources/quotation-quotations/quotation-quotations-resource.module';
import { CurrencyListResourceModule } from "libraries/service/resources/currency-list/currency-list-resource.module";
import { ErrorTracingModule } from 'libraries/service/error-tracing/error-tracing.module';
import { ThTravellerModule } from "app_quotation/shared/components/table/th-traveller/th-traveller.module";
import { ThTextModule } from "libraries/component/table/th-text/th-text.module";
import { ThPriceModule } from "app_quotation/shared/components/table/th-price/th-price.module";
import { ColEndModule } from "app_quotation/shared/components/table/col-end/col-end.module";
import { TableKeyboardNavigationModule } from 'libraries/service/table-keyboard-navigation/table-keyboard-navigation.module';
import { CellPriceModule } from "libraries/component/table/cell-price/cell-price.module";
import { CurrenciesResourceModule } from "libraries/service/resources/currencies/currencies-resource.module";
import { QuotationPricePipesModule } from "app_quotation/shared/pipes/quotation-price-pipes.module";
import { ConfirmDialogModule } from 'libraries/component/dialogs/confirm-dialog/confirm-dialog.module';
import { LabelModule } from 'libraries/service/label/label.module';
import { MatTableModule } from "@angular/material/table";
import { MatDialogModule } from "@angular/material/dialog";

@NgModule({
    imports: [
        CurrenciesResourceModule,
        CommonModule,
        ConfigurationResourceModule,
        CostFormGeneratorModule,
        CostGridBlockContentModule,
        CostGridBlockValueModule,
        CostTableDataModule,
        TableKeyboardNavigationModule,
        CurrencyListResourceModule,
        ColEndModule,
        ErrorTracingModule,
        ThTextModule,
        ThTravellerModule,
        ThPriceModule,
        MatTableModule,
        PriceModule,
        QuotationQuotationsResourceModule,
        CellPriceModule,
        QuotationPricePipesModule,
        ConfirmDialogModule,
        MatDialogModule,
        LabelModule,
    ],
    exports: [
        CostGridComponent,
    ],
    declarations: [
        CostGridComponent,
    ],
})
export class CostGridModule {
}
